'use strict'

const stringify = require('./stable')

module.exports = stringify
stringify.default = stringify



//////////////////
// WEBPACK FOOTER
// ./~/safe-stable-stringify/index.js
// module id = E3CP
// module chunks = 0